/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React from "react";
import { NotFoundPage } from "@vlinder-web/not-found-page-widget-react";
import { useTheme } from "../../../providers/theme";

export const ContainerComm = (props: any) => {
  const theme = useTheme();
  return (
    <NotFoundPage
    // buttonStyle={{ backgroundColor: theme?.colors?.primary }}
    />
  );
};
